import styled from 'styled-components';

export const OuterWrapper = styled.div`
  width: 100%;
`;

export const Results = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 9px;
  padding: 10px 0;

  ${({ theme }) => theme.breakpoints.down('lg')} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    grid-template-columns: 1fr;
  }
`;

export const ResultCard = styled.div<{
  disabled: boolean;
  onClick?: () => void;
}>`
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  min-height: 80px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-shadow: ${({ theme }) => theme.shadows[24]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${(props) =>
    props.disabled
      ? ''
      : props.onClick
        ? `cursor: pointer;
  &:hover {
    box-shadow: ${props.theme.shadows[24]};
  }
  `
        : 'cursor: inherit'}

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows[24]};
  }
`;

export const TypeName = styled.div`
  font-size: 14px;
`;

export const Value = styled.div`
  font-size: 18px;
  line-break: anywhere;
`;
